import { AxiosHeaders } from 'axios';
import AuthService from '@/services/auth.service';

export const authHeader = async (): Promise<AxiosHeaders> => {
  const accessToken = await AuthService.getValidAccessToken();

  const headers = new AxiosHeaders();

  if (accessToken) {
    headers.set('access-token', `${accessToken}`);
  }

  return headers;
};
